import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

// The last three are the evidence cards: a box resolved to the wrong batch, a
// reset window that opened before today's 04:00, and a box blocked by a scan
// from a previous working day (what "rejected at the start of the day" means).
const KPIS = [
  { key: 'rejections' },
  { key: 'boxes' },
  { key: 'prefixes' },
  { key: 'devices' },
  { key: 'batchMismatches', highlight: true },
  { key: 'windowBeforeDayStart', highlight: true },
  { key: 'blockedByPreviousDay', highlight: true }
]

const Kpis = ({ totals }) => {
  const { t } = useTranslation()

  return (
    <div className='grid grid-cols-2 md:grid-cols-4 xl:grid-cols-7 gap-4'>
      {KPIS.map(({ key, highlight }) => {
        const value = Number(totals?.[key] || 0)
        const alert = highlight && value > 0
        return (
          <div
            key={key}
            className={`rounded-lg border p-4 ${alert ? 'border-amber-300 bg-amber-50' : 'border-gray-200 bg-white'}`}
            title={t(`system.scanRejections.kpis.${key}Hint`)}
          >
            <div className='text-xs uppercase tracking-wide text-gray-500'>{t(`system.scanRejections.kpis.${key}`)}</div>
            <div className={`mt-1 text-2xl font-semibold ${alert ? 'text-amber-700' : 'text-greenPrimary'}`}>
              {value.toLocaleString('es-MX')}
            </div>
          </div>
        )
      })}
    </div>
  )
}

Kpis.propTypes = {
  totals: PropTypes.object
}

export default Kpis
